import {Component, Inject, OnInit} from '@angular/core';
import {WidgetService} from '../../../../../domain/widget/service/widget.service';
import {AvailableWidget} from '../../../../../domain/widget/model/available-widget';
import {SafeSubscriberDirective} from '../../../../../application/app-context/safe-subscriber.directive';
import {WidgetSize} from '../../../../../domain/widget/model/widget-size.enum';
import {WidgetDetail} from '../../../../../domain/widget/model/widget-detail';
import {ApplicationName} from '../../../../../domain/core/model/aplication-name.enum';
import {ApplicationNamePipe} from '../../../../pipes/application-name.pipe';
import {UserContextService} from '../../../../../application/app-context/user-context/user-context.service';
import {ApplicationState} from '../../../../../domain/app-launcher/model/app-launcher';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
             selector: 'app-home-dashboard-widget-catalog',
             templateUrl: './home-dashboard-widget-catalog-dialog.component.html',
             styleUrls: ['./home-dashboard-widget-catalog-dialog.component.scss']
           })
export class HomeDashboardWidgetCatalogDialogComponent extends SafeSubscriberDirective implements OnInit {

  readonly WidgetSize = WidgetSize;

  dashboardId: number | undefined;
  availableWidgets: Array<AvailableWidget> | undefined;
  filteredAvailableWidgets: Array<AvailableWidget> | undefined;
  widgetsSelectedSize: Map<AvailableWidget, WidgetSize> | undefined;
  availableWidgetsApps: Array<ApplicationName> | undefined;
  isCatalogLoaded = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private widgetService: WidgetService,
              private userContextService: UserContextService) {
    super();
  }

  ngOnInit(): void {
    const availableApplications = new Set(this.userContextService
                                              .getUserContext()
                                              .user
                                              .appLauncher
                                              .applications
                                              .filter(app => app.state === ApplicationState.IS_ENABLED)
                                              .map(app => app.appId));
    this.dashboardId = this.data.dashboardId;
    this.subs.push(
      this.widgetService.getAvailableWidgetForUser()
          .subscribe((result: Array<AvailableWidget>) => {
            this.availableWidgets = result;
            this.filteredAvailableWidgets = result;
            this.widgetsSelectedSize = new Map(result.map(widget => [widget, widget.availableSizes[widget.availableSizes.length - 1]]));
            const widgetsApps = [...new Set(result.reduce((acc, widget) => acc.concat(widget.applicationNames), []))];
            this.availableWidgetsApps = this.filterAvailableApps(widgetsApps, availableApplications);
            this.isCatalogLoaded = !this.isCatalogLoaded;
          })
    );
  }

  public isSizeSelected(availableWidget: AvailableWidget, size: WidgetSize): boolean {
    if (this.widgetsSelectedSize) {
      return this.widgetsSelectedSize.get(availableWidget) === size;
    }
    return false;
  }

  public selectSize(availableWidget: AvailableWidget, availableSize: WidgetSize): void {
    if (this.widgetsSelectedSize) {
      this.widgetsSelectedSize.set(availableWidget, availableSize);
    }
  }

  public addWidget(availableWidget: AvailableWidget): void {
    if (this.dashboardId && this.widgetsSelectedSize) {
      const size = this.widgetsSelectedSize.get(availableWidget);

      if (size) {
        this.subs.push(
          this.widgetService.addWidget(this.dashboardId, availableWidget.widgetName, size)
              .subscribe((result: WidgetDetail) => this.widgetService.updateWidgetsSubject.next(result))
        );
      }
    }
  }

  public getMockedWidgetDetail(availableWidget: AvailableWidget, widgetSize: WidgetSize): WidgetDetail | undefined {
    return new WidgetDetail(availableWidget.widgetName,
                            availableWidget.widgetName,
                            availableWidget.applicationNames,
                            0,
                            widgetSize);
  }

  public isOfSize(availableWidget: AvailableWidget, widgetSize: WidgetSize): boolean {
    if (this.widgetsSelectedSize) {
      return widgetSize === this.widgetsSelectedSize.get(availableWidget);
    }
    return undefined;
  }

  public onSelectedSolution(applicationName: ApplicationName): void {
    if (!applicationName) {
      this.filteredAvailableWidgets = this.availableWidgets;
    } else {
      this.filteredAvailableWidgets = this.availableWidgets.filter(widget => widget.applicationNames.indexOf(applicationName) >= 0);
    }
  }

  public searchSolution(term: string, applicationName: ApplicationName): boolean {
    const solution = new ApplicationNamePipe().transform(applicationName);
    return solution.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) >= 0;
  }

  private filterAvailableApps(widgetsApps: ApplicationName[], availableApplications: Set<string>): ApplicationName[] {
    let availableWidgets = widgetsApps.filter(widgetApp => availableApplications.has(widgetApp === 'funding_tender'
                                                                                     ? 'funding-tender'
                                                                                     : widgetApp));
    availableWidgets.push(ApplicationName.DASHBOARD);
    return availableWidgets;
  }
}
